import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import styles from './styles.module.scss';
import { IBindingAction, IBindingCallback1 } from '../../common/models/callback';
import { IFormattedMessage } from '../../common/models/common/IFormattedMessage';
import Tooltip from '../Tooltip';
import { concat } from '../../common/helpers/arrayHelper';

interface IProps {
  textIntlId: string;
  defaultMessage?: string;
  tooltip?: IFormattedMessage;
  onClick?: IBindingAction | IBindingCallback1<React.MouseEvent<HTMLButtonElement, MouseEvent>>;
  variant?: 'primary' | 'secondary' | 'tertiary';
  size?: 'sm'| 'md' | 'lg';
  disabled?: boolean;
  enableAction?: boolean;
  icon?: JSX.Element;
  iconPosition?: 'left' | 'right';
  type?: 'button' | 'submit';
}

const RegularButton: FunctionComponent<IProps> = ({
  tooltip,
  textIntlId,
  onClick,
  variant = 'primary',
  size = 'md',
  iconPosition = 'left',
  disabled,
  enableAction,
  defaultMessage,
  icon,
  type = 'button'
}) => {
  const button = (
    <Button
      bsPrefix={concat('regular-button',
        styles.btn,
        styles[variant],
        styles[size],
        disabled && `${styles.disabled} disabled-regular-button`,
        !enableAction && disabled && styles.withoutAction)}
      type={type}
      onClick={(Boolean(disabled) && !enableAction) ? undefined : onClick}
    >
      {icon && <span className={`${styles.icon} ${styles[iconPosition]}`}>{icon}</span>}
      <span><FormattedMessage id={textIntlId} defaultMessage={defaultMessage || textIntlId} /></span>
    </Button>
  );

  return tooltip
    ? <Tooltip className={styles.bttnTooltip} content={<FormattedMessage {...tooltip} />}>{button}</Tooltip>
    : button;
};

export default RegularButton;
